import React from 'react';
import MediaTranslationContext from 'app/app/mediaSelector/contexts/MediaTranslationContext';

function MediaTranslationProvider(props) {

    const trans = window.main_theme_objects.media_select_translations; //just like window.adminurl, we can get the object from window containing trans.

    return (
        <MediaTranslationContext.Provider value={trans}>
            {props.children}
        </MediaTranslationContext.Provider>
    );
}

export default MediaTranslationProvider;
